// extracted by mini-css-extract-plugin
export default {"details":"jIeZ","details-code":"LBYW","detailsCode":"LBYW","details-button":"Vi_m","detailsButton":"Vi_m"};